// extracted by mini-css-extract-plugin
export default {"ActionsCell":"gOWUF9cx","historyWrapper":"Gg93gioL","historyDefault":"mOBW0R6P","historyChanged":"Qos2qyJf"};